
import imgQ1 from "/ui/QAImges/conflictQues01.png";
import imgA1 from "/ui/QAImges/conflictAns01.png";

import videoQ2 from "/ui/QAImges/conflictQues02.mp4";

import imgQA3 from "/ui/QAImges/conflictQuesAns03.png";

import imgQA5 from "/ui/QAImges/conflictQuesAns05.png";

import imgQA8 from "/ui/QAImges/conflictQuesAns08.png";

import imgQA10 from "/ui/QAImges/conflictQuesAns010.png";




// questions.js

export const quiz_Questions = {
  conflict: [
    {
      id: 1,
      text: `दुनिया गर्म नहीं, ठंडी हो रही है. कनाडा और पोलैंड में रहने वाले कुछ यूज़र्स सोशल मीडिया पर ये कह रहे हैं कि धरती असल में गर्म नहीं,ठंडी हो रही है. ऐसा वो अपने इलाक़ों में सामान्य से ज़्यादा ठंड को देखते हुए कह रहे हैं. इन यूज़र्स का दावा है कि वैज्ञानिक झूठ बोल रहे हैं और असल में धरती ठंडी हो रही है. क्या है <span>Fact</span> है या <span>Fake</span>?`,
      img: null,
      video: null,
      answer: "FAKE",
      ansImg: null,
      ansVideo: null,
      ansIFrame: null,
      context: `
      मौसम यानी धरती के वातावरण में कुछ दिनों या हफ़्तों में होने वाले बदलाव. जलवायु यानी ऐसे हालात और रुझानों को दर्शाना, जो लंबे समय तक रहते हैं.<br>
      फ़िलीपींस के क्लाइमेट साइंटिस्ट डॉक्टर जोसेफ़ बासकोंसिलो कहते हैं, "लंबे समय के तापमान रिकॉर्ड साफ़ दिखाते हैं कि धरती की सतह लगातार गर्म हो रही है, भले ही कुछ जगहों पर थोड़े समय के लिए ठंडक महसूस की जाए.
      विश्व मौसम विज्ञान संगठन के मुताबिक़, 1980 से अब तक हर दशक पिछले की तुलना में ज़्यादा गर्म दशक रहा है और यह रुझान आगे भी जारी रहने की आशंका है.
      संगठन ने बताया कि साल 2024 अब तक का सबसे गर्म साल रहा. इस साल धरती का औसत तापमान 1800 के दशक के अंत की तुलना में करीब 1.55 डिग्री सेल्सियस ज़्यादा था.<br>
      पूरी स्टोरी पढ़ने के लिए:<br>
      <a href="https://www.bbc.com/hindi/articles/c8x1n195wyjo" 
         target="_blank" 
         rel="noopener noreferrer">
         https://www.bbc.com/hindi/articles/c8x1n195wyjo
        </a>
      </span>`
    },
    {
      id: 2,
      text: `इस वीडियो में दिखाया गया है कि प्रयागराज में लोगों के घर और आस-पास का इलाक़ा पानी में डूबा हुआ है. 
            आपको क्या लगता है कि ये <span>Fake</span> है या <span>Fact?</span>`,
      img: null,
      video: videoQ2,
      answer: "FACT", //Fact
      ansImg: null,
      ansVideo: null,
      ansIFrame: "https://www.youtube.com/embed/619MLfMrhr8?autoplay=1&mute=1&controls=1",
      context: `
          ये वीडियो बिलकुल सही है और वीडियो में <span>BBC News</span> संवाददाता प्रयागराज से इस आपदा के बीच से रिपोर्टिंग करते दिख रहे हैं.

          पूरी रिपोर्ट यहां देखिए:
          <a href="https://www.youtube.com/watch?v=619MLfMrhr8"
             target="_blank"
             rel="noopener noreferrer">
             https://www.youtube.com/watch?v=619MLfMrhr8
          </a>
          `
    },
    {
      id: 3,
      text: `यूपी में एक गांव है, जो कुछ महीनों के लिए टापू बन जाता है.`,
      img: imgQA3,
      video: null,
      answer: "FACT",
      ansImg: imgQA3,
      ansVideo: null,
      ansIFrame: null,
      context: `
              ये तस्वीर सही है. बारिश के कारण झांसी का  पचवई गांव  पांच महीने के लिए टापू बन जाता है. हालांकि यूपी का बुंदेलखंड सूखे के कारण सुर्खियों में रहता है. मगर बरसात के दिनों में जब ये इलाक़ा टापू बनता है, तब इस गांव को स्कूल, अस्पताल और बाज़ार से जोड़ने वाली सड़क पानी में डूब जाती है. गांव तक जाने की बस ये एक सड़क है. ऐसे हालात में बच्चे स्कूल कुछ इस तरह से जाते हैं.
              बीबीसी न्यूज़ हिन्दी की ग्राउंड रिपोर्ट यहां पढ़िए-
          <a href="https://www.bbc.com/hindi/articles/c17nvx4w4w7o"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/c17nvx4w4w7o
          </a>
          `
    },
    {
      id: 4,
      text: `अमेज़न के जंगलों में हवाई नदियां बहती हैं. ये नदियां आसमान में पानी लाती-ले जाती हैं.`,
      img: null,
      video: null,
      answer: "FACT",
      ansImg: null,
      ansVideo: null,
      ansIFrame: null,
      context: `
             विशाल अमेज़न क्षेत्र में अपनी ख़ुद की मौसम प्रणालियां हैं.
             इसके जंगल अटलांटिक महासागर से आने वाली नमी को सर्कुलेट करते हैं, जिन्हें आकाश में बहने वाली "हवाई नदियां" या "फ्लाइंग रिवर्स" कहा जाता है.
             ये वायुमंडलीय नदियां सबसे पहले अमेज़न के पूर्वी हिस्से में, यानी अटलांटिक के पास बारिश करती हैं. इसके बाद ज़मीन और पेड़ों से पानी भाप बनकर ऊपर उठता है, जो वाष्पोत्सर्जन की प्रक्रिया से हवा में फैलता है और वर्षावन के दूसरे हिस्सों पर गिरने से पहले पश्चिम की ओर बढ़ता है.
             वर्षावन के एक हिस्से से दूसरे हिस्से तक पानी का यह चक्र पूरे अमेज़न में चलता है. यही बताता है कि यह विशाल वर्षावन इतने लंबे समय तक कैसे फलता-फूलता रहा है.
             वायुमंडलीय नदियां वास्तव में जलवाष्प की नदियां हैं, जो आसमान में पानी को लाती-ले जाती हैं. <br>
             पूरी रिपोर्ट यहां पढ़िए:<br>

          <a href="https://www.bbc.com/hindi/articles/ceq0ww2lgqyo"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/ceq0ww2lgqyo
          </a>
          `
    },
    {
      id: 5,
      text: `भारत दुनिया का सबसे बड़ा सोलर प्रोजेक्ट प्लांट लद्दाख में लगाने की योजना बना रहा है.`,
      img: imgQA5,
      video: null,
      answer: "FACT",
      ansImg: imgQA5,
      ansVideo: null,
      ansIFrame: null,
      context: `
                ये सही है.<br>
                केंद्र शासित प्रदेश लद्दाख की प्रशासनिक राजधानी लेह से क़रीब 175 किलोमीटर दूर लेह-मनाली हाईवे पर पांग और डेबरिंग नाम की दर्जन भर घरों की बस्तियों के बीच पड़ने वाले मोरे प्लेंस में 48 हज़ार एकड़ ज़मीन पर 11 गीगावॉट क्षमता का विशाल सोलर प्रोजेक्ट प्रस्तावित है.
                प्रधानमंत्री नरेंद्र मोदी ने 15 अगस्त 2020 को लाल किले से दिए भाषण में लद्दाख में मेगा सोलर पार्क बनाने की घोषणा की थी.
                ये मेगा सोलर प्रोजेक्ट कब तक पूरा होगा इसे लेकर फिलहाल अधिकारिक जानकारी नहीं है. 11 GW के इस प्रोजेक्ट से लाखों घरों में बिजली आएगी. मगर ये इलाका पश्मीना भेड़ों और बकरियां का भी घर है. ये दुनिया का सबसे शानदार पश्मीना पैदा करते हैं. 
                क्या ये सोलर पावर प्लांट पश्मीना के लिए ख़तरा है? ये चरवाहे क्यों चिंता में हैं?<br>
                बीबीसी न्यूज़ हिन्दी की ग्राउंड रिपोर्ट यहां पढ़िए- <br>

          <a href="https://www.bbc.com/hindi/articles/ce3xkpnxq6zo"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/ce3xkpnxq6zo
          </a>
          `
    },
    {
      id: 6,
      text: `वंदे भारत ट्रेन सिर्फ़ 52 सेकेंड में 0 से 100 किलोमीटर प्रति घंटे की रफ़्तार पकड़ सकती है. ये दावा सही है या ग़लत?`,
      img: null,
      video: null,
      answer: "FACT",
      ansImg: null,
      ansVideo: null,
      ansIFrame: null,
      context: `
                ये फ़ैक्ट है.<br>
                ये सही है. पीआईबी के मुताबिक़, वंदे भारत ट्रेन सिर्फ़ 52 सेकेंड में 100 किलोमीटर प्रति घंटे की रफ़्तार पकड़ सकती है.<br>
                वंदे भारत ट्रेन पर पूरी रिपोर्ट यहां पढ़िए.<br>

          <a href="https://www.bbc.com/hindi/articles/c62nwygywxqo"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/c62nwygywxqo
          </a>
          `
    },
    {
      id: 7,
      text: `दावा- दुनिया के महासागरों में अंधेरा छा रहा है. ये दावा सही है या फ़ेक?`,
      img: null,
      video: null,
      answer: "FACT",
      ansImg: null,
      ansVideo: null,
      ansIFrame: null,
      context: `
                ग्लोबल चेंज बायोलॉजी में छपे अध्ययन में पाया गया है कि 2003 और 2022 के बीच वैश्विक महासागर का 21 फ़ीसदी हिस्सा अंधकारमय हुआ है.<br>
                अध्ययन के अनुसार, ओशन डार्कनिंग का कारण पानी में शैवालों की संख्या बढ़ने की प्रक्रिया में बदलाव और समुद्र की सतह के तापमान में परिवर्तन माना जाता है.
                ये सबसे अधिक तटीय क्षेत्रों में देखा जाता है, जहां पोषक तत्वों से भरपूर पानी सतह पर आ जाता है और अधिक बारिश के कारण भूमि से कृषि अपशिष्ट और तलछट पानी में चले जाते हैं, जिनसे समुद्र की सतह पर रहने वाले सूक्ष्म जीवों को, जिन्हें प्लवक कहते हैं, पोषण मिलता है.<br>
                पूरी रिपोर्ट यहां पढ़िए<br>

          <a href="https://www.bbc.com/hindi/articles/cr4z1qq32lqo"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/cr4z1qq32lqo
          </a>
          `
    },
    {
      id: 8,
      text: `आंध्र प्रदेश में एक गांव है, जो नदी पर है. ये दावा सही है या ग़लत?`,
      img: imgQA8,
      video: null,
      answer: "FACT",
      ansImg: imgQA8,
      ansVideo: null,
      ansIFrame: null,
      context: `
                ये गांव आंध्र प्रदेश के पोलावरम ज़िले के चिंतूरू में सबरी नदी पर है. यहां कुछ परिवार नाव पर रह रहे हैं.<br>
                पूरी रिपोर्ट यहां पढ़िए-<br>

          <a href="https://www.bbc.com/hindi/articles/ckgnk7kev4yo"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/ckgnk7kev4yo
          </a>
          `
    },
    {
      id: 9,
      text: `सर्दियों में हिमालय में बर्फ़बारी कम हो रही है. ये सही है या ग़लत?`,
      img: null,
      video: null,
      answer: "FACT",
      ansImg: null,
      ansVideo: null,
      ansIFrame: null,
      context: `
                पर्यावरण वैज्ञानिकों का कहना है कि हिमालय पर सर्दियों में बहुत कम बर्फ़बारी हो रही है और ऐसे मौसम में जब पहाड़ बर्फ़ से ढंके होने चाहिए, इसके कई हिस्से में पहाड़ नंगे और पथरीले दिखाई देने लगे हैं.<br>
                वैज्ञानिकों का कहना है कि 1980 से 2020 के बीच औसत बर्फ़बारी के मुक़ाबले, पिछले पाँच सालों में सर्दियों में बर्फ़बारी में कमी देखी गई है.<br>
                पूरी रिपोर्ट यहां पढ़िए- <br>

          <a href="https://www.bbc.com/hindi/articles/c9dvq9jqwxlo"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/c9dvq9jqwxlo
          </a>
          `
    },
    {
      id: 10,
      text: `इस तस्वीर के साथ दावा किया है कि ये देसी फ्रिज है, जो लकड़ी और पत्थर से बना हुआ है. इसके लिए बिजली नहीं लगती. क्या आपको लगता है कि ये दावा सही है या गलत?`,
      img: imgQA10,
      video: null,
      answer: "FACT",
      ansImg: imgQA10,
      ansVideo: null,
      ansIFrame: null,
      context: `
                कश्मीर की ऊँची पहाड़ियों और घाटियों से घिरा है उरी ज़िले का दुदरन गाँव.<br>
                ये गांव दूध और खाने-पीने के सामान को सुरक्षित रखने के लिए एक ख़ास चीज का इस्तेमाल करता है. यहां के लोग इसे 'देसी रेफ़्रिजरेटर' भी कहते हैं.<br>
                इसे यहाँ की स्थानीय भाषा में 'डडूर' कहा जाता है.<br>
                पूरी रिपोर्ट यहां पढ़िए<br>


          <a href="https://www.bbc.com/hindi/articles/c77zvm4z3pyo"
             target="_blank"
             rel="noopener noreferrer">
             https://www.bbc.com/hindi/articles/c77zvm4z3pyo
          </a>
          `
    },


  ],
  cyclone: [
    {
      id: 1,
      text: "cycloneQuestion1",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 2,
      text: "cycloneQuestion2",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 3,
      text: "cycloneQuestion3",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 4,
      text: "cycloneQuestion4",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 5,
      text: "cycloneQuestion5",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 6,
      text: "cycloneQuestion6",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
  ],
  remote: [
    {
      id: 1,
      text: "remoteQuestion1",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 2,
      text: "remoteQuestion2",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 3,
      text: "remoteQuestion3",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 4,
      text: "remoteQuestion4",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 5,
      text: "remoteQuestion5",
      img: "./ui/Image.png",
      answer: "FAKE"
    },
    {
      id: 6,
      text: "remoteQuestion6",
      img: "./ui/Image.png",
      answer: "FAKE"
    },

  ]
}

